// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/style/director-style.css
// module id = 920
// module chunks = 1